import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Invoice = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="invoice icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 37.5C19 36.6716 19.6716 36 20.5 36L33.5 36C34.3284 36 35 36.6716 35 37.5C35 38.3284 34.3284 39 33.5 39H20.5C19.6716 39 19 38.3284 19 37.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 25.5C19 24.6716 19.6716 24 20.5 24H33.5C34.3284 24 35 24.6716 35 25.5C35 26.3284 34.3284 27 33.5 27H20.5C19.6716 27 19 26.3284 19 25.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 31.5C19 30.6716 19.6716 30 20.5 30H33.5C34.3284 30 35 30.6716 35 31.5C35 32.3284 34.3284 33 33.5 33H20.5C19.6716 33 19 32.3284 19 31.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 25.5C39 24.6716 39.6716 24 40.5 24H43.5C44.3284 24 45 24.6716 45 25.5C45 26.3284 44.3284 27 43.5 27H40.5C39.6716 27 39 26.3284 39 25.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 37.5C39 36.6716 39.6716 36 40.5 36H43.5C44.3284 36 45 36.6716 45 37.5C45 38.3284 44.3284 39 43.5 39H40.5C39.6716 39 39 38.3284 39 37.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 31.5C39 30.6716 39.6716 30 40.5 30H41.5C42.3284 30 43 30.6716 43 31.5C43 32.3284 42.3284 33 41.5 33H40.5C39.6716 33 39 32.3284 39 31.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54 1.50006C54 0.877951 53.616 0.320405 53.0348 0.0986212C52.4535 -0.123162 51.7957 0.036853 51.3813 0.500834L48.4696 3.76068L45.4897 0.489862C45.2055 0.177871 44.803 6.39116e-05 44.3809 6.39116e-05C43.9588 6.39116e-05 43.5563 0.177871 43.2721 0.489862L40.2811 3.77279L37.2902 0.489862C37.006 0.177871 36.6034 6.39116e-05 36.1814 6.39116e-05C35.7593 6.39116e-05 35.3568 0.177871 35.0726 0.489862L32.0816 3.77279L29.0907 0.489862C28.8065 0.177871 28.4039 6.39116e-05 27.9819 6.39116e-05C27.5598 6.39116e-05 27.1573 0.177871 26.8731 0.489862L23.8821 3.77279L20.8912 0.489862C20.6069 0.177871 20.2044 6.39116e-05 19.7824 6.39116e-05C19.3603 6.39116e-05 18.9578 0.177871 18.6735 0.489862L15.6716 3.78491L12.5987 0.478858C12.1789 0.0271592 11.5253 -0.121557 10.9514 0.10399C10.3774 0.329536 10 0.883381 10 1.50006V62.5001C10 63.1167 10.3774 63.6706 10.9514 63.8961C11.5253 64.1217 12.1789 63.973 12.5987 63.5213L15.6716 60.2152L18.6735 63.5103C18.9578 63.8223 19.3603 64.0001 19.7824 64.0001C20.2044 64.0001 20.6069 63.8223 20.8912 63.5103L23.8821 60.2273L26.8731 63.5103C27.1573 63.8223 27.5598 64.0001 27.9819 64.0001C28.4039 64.0001 28.8065 63.8223 29.0907 63.5103L32.0816 60.2273L35.0726 63.5103C35.3421 63.8061 35.7186 63.982 36.1185 63.9987C36.5183 64.0155 36.9083 63.8718 37.2017 63.5996L40.25 60.23L43.1088 63.5101C43.3931 63.8221 43.7956 63.9999 44.2176 63.9999C44.6397 63.9999 45.0422 63.8221 45.3265 63.5101L48.3284 60.215L51.4013 63.5211C51.8211 63.9728 52.4747 64.1215 53.0486 63.896C53.6226 63.6704 54 63.1166 54 62.4999V1.50006ZM51 5.43117L49.5994 6.99929C49.3165 7.31599 48.9127 7.49795 48.488 7.50005C48.0634 7.50214 47.6578 7.32416 47.3718 7.01027L44.3809 3.72734L41.39 7.01027C41.1057 7.32226 40.7032 7.50006 40.2811 7.50006C39.8591 7.50006 39.4566 7.32226 39.1723 7.01027L36.1814 3.72734L33.1905 7.01027C32.9062 7.32226 32.5037 7.50006 32.0816 7.50006C31.6596 7.50006 31.257 7.32226 30.9728 7.01027L27.9819 3.72734L24.9909 7.01027C24.7067 7.32226 24.3042 7.50006 23.8821 7.50006C23.4601 7.50006 23.0575 7.32226 22.7733 7.01027L19.7824 3.72734L16.7914 7.01027C16.5089 7.32033 16.1095 7.49795 15.6901 7.50005C15.2706 7.50214 14.8695 7.32851 14.5839 7.02127L13 5.31717V58.683L14.5839 56.9789C14.8695 56.6716 15.2706 56.498 15.6901 56.5001C16.1095 56.5022 16.5089 56.6798 16.7914 56.9899L19.7824 60.2728L22.7733 56.9899C23.0575 56.6779 23.4601 56.5001 23.8821 56.5001C24.3042 56.5001 24.7067 56.6779 24.9909 56.9899L27.9819 60.2728L30.9728 56.9899C31.257 56.6779 31.6596 56.5001 32.0816 56.5001C32.5037 56.5001 32.9062 56.6779 33.1905 56.9899L36.2707 60.3709C36.2707 60.3709 37 59.5 39.0091 56.9897C39.2728 56.6602 39.6958 56.4999 40.1179 56.4999C40.5399 56.4999 40.9425 56.6777 41.2267 56.9897L44.2176 60.2726L47.2086 56.9897C47.4911 56.6796 47.8905 56.502 48.3099 56.4999C48.7294 56.4978 49.1305 56.6715 49.4161 56.9787L51 58.6828V5.43117Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 12V20H22.36C23.9943 20 25 19.1429 25 17.5886C25 16.5714 24.5543 15.9429 23.8 15.6343C24.3029 15.3714 24.5886 14.8114 24.5886 14.16C24.5886 12.7086 23.6629 12 22.3029 12H19ZM22.75 14.2743C22.75 15.1086 21.5943 15.1086 21 15.1086V13.3714C21.6286 13.3714 22.75 13.3714 22.75 14.2743ZM23 17.5886C23 18.6286 21.9257 18.6286 21 18.6286V16.48C21.9257 16.48 23 16.5 23 17.5886ZM27 20V18H28.5V14H27V12H32V14H30.5V18H32V20H27ZM33.5 12V20H38.4999V18H35.5V12H33.5ZM40 12V20H44.9999V18H42V12H40Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M18 46C18 44.3431 19.3431 43 21 43H43C44.6569 43 46 44.3431 46 46V50C46 51.6569 44.6569 53 43 53H21C19.3431 53 18 51.6569 18 50V46Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43 46H21L21 50H43V46ZM21 43C19.3431 43 18 44.3431 18 46V50C18 51.6569 19.3431 53 21 53H43C44.6569 53 46 51.6569 46 50V46C46 44.3431 44.6569 43 43 43H21Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
